import { ApiRequestError } from '@/shared/api/api-error';

export const FIELD_SECTIONS = [
  { id: 'progress', label: 'Progress' },
  { id: 'today', label: 'Today' },
  { id: 'engagement', label: 'Brief & decisions' },
  { id: 'build', label: 'Build' },
  { id: 'inbox', label: 'Conversations' },
  { id: 'board', label: 'Tickets' },
  { id: 'reviews', label: 'Pull requests' },
  { id: 'documents', label: 'Documents' },
  { id: 'operations', label: 'Runs & release' },
  { id: 'assessment', label: 'Assessment' },
] as const;

export type FieldSection = (typeof FIELD_SECTIONS)[number]['id'];

/** Never make an untrusted source link executable in the learner's browser. */
export function safeFieldLink(value: string | null | undefined): string | null {
  if (!value) return null;
  if (value.startsWith('/') && !value.startsWith('//') && !value.includes('\\')) return value;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}

export function fieldErrorMessage(error: unknown): string {
  if (
    error instanceof ApiRequestError &&
    error.status === 503 &&
    ['field_disabled', 'field_unavailable'].includes(error.code)
  )
    return 'Workbench is currently unavailable. Please try again shortly.';
  return error instanceof Error
    ? error.message
    : 'Something went wrong. Your saved work is still available.';
}
